import styled from 'styled-components';

const Wrapper = styled.div`
  .container_modal_wrapper .component_footer {
    margin-top: 12px;
  }

  .component_twitter_report_time {
    margin-top: 28px;
  }
`;

export default Wrapper;
